import { observer } from 'mobx-react-lite'
import { type OCRScopingJobMainPanelViewModel } from '@/features/jobs/scoping/OCRScopingJobMainPanelViewModel'
import { formatOCRScopeWorkStatus } from '@/features/jobs/scoping/ocr-scope-work-formatters'
import { OCRScopeJobDetailHeader } from '@/features/jobs/scoping/components/OCRScopeJobDetailHeader'

export interface OCRScopeJobDetailHeaderContainerProps {
  vm: OCRScopingJobMainPanelViewModel
}

export const OCRScopeJobDetailHeaderContainer = observer(
  function OCRScopeJobDetailHeaderContainer({
    vm,
  }: OCRScopeJobDetailHeaderContainerProps) {
    const selectedScopeWork = vm.selectedScopeWork
    if (!vm.hasScopeWork) {
      return null
    }

    return (
      <OCRScopeJobDetailHeader
        title={selectedScopeWork.jobName || selectedScopeWork.fileName}
        statusName={formatOCRScopeWorkStatus(selectedScopeWork.status)}
        isHealthy={vm.isStatusHealthy}
        showConfidenceLevel={vm.canManageOCRScopingJobs && !vm.isErrorOccurred}
        confidenceLevel={selectedScopeWork.confidenceLevel}
        showTotal={vm.hasJob}
        total={vm.editor.job.total}
        createdByName={selectedScopeWork.createdByName}
      />
    )
  },
)
